let modalCounter = 0;

export const generateModalId = () => {
    modalCounter += 1;

    return `modal-${modalCounter}`;
};

export const isBrowser = () => typeof window !== "undefined" && typeof document !== "undefined";

export const getScrollbarWidth = () => {
    if (!isBrowser()) {
        return 0;
    }

    return window.innerWidth - document.documentElement.clientWidth;
};
